import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { colorSet, theme } from '@components/Provider';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { HomeComponentContainer } from './styled';
import { ANSWER_A, QUESTION_Q } from '../Assets/index';
import { withStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { MediaQuery } from '../HomePresenter';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';

const Accordion = withStyles({
  root: {
    transition: 'all 0.2s ease-in',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 0,
      '& .MuiAccordionDetails-root, .MuiAccordionSummary-root': {
        backgroundColor: colorSet.gray100
      },
      '&:hover': {
        '& .MuiAccordionSummary-root': {
          backgroundColor: colorSet.gray200
        }
      }
    },
    '&:hover': {
      '& .MuiAccordionSummary-root': {
        backgroundColor: colorSet.gray200
      }
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderRadius: 16,
    marginBottom: -1,
    minHeight: 56,
    transition: 'all 0.2s ease-in',
    '&$expanded': {
      minHeight: 56
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 14px 0 12px'
    }
  },
  content: {
    gap: '13px',
    '& .imgContainer': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '&$expanded': {
      margin: '12px 0'
    },
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    flexDirection: 'row',
    padding: '20px 16px',
    borderRadius: 16,
    gap: '16px',
    marginTop: 10,
    transition: 'all 0.2s ease-in',
    '& .imgAnswer': {
      paddingTop: 6
    },
    '& a': {
      color: colorSet.primary500
    },
    '& .subTitle': {
      marginTop: 8
    },
    '& .tableContent': {
      width: 320,
      height: 68,
      border: `1px solid ${colorSet.gray300}`,
      borderCollapse: 'collapse',
      '& th': {
        border: `1px solid ${colorSet.gray300}`,
        padding: '0 12px',
        lineHeight: '34px',
        background: colorSet.gray000,
        fontSize: 13,
        width: 200,
        textAlign: 'left'
      },
      '& td': {
        border: `1px solid ${colorSet.gray300}`,
        lineHeight: '34px',
        padding: '0 12px',
        background: colorSet.gray200,
        fontSize: 13,
        fontWeight: 500
      }
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 12px',
      '& button': {
        height: 40,
        width: '100%'
      }
    }
  }
}))(MuiAccordionDetails);

const CapaQuestion = () => {
  const { mainTitle, container } = useStyles();
  const { md, sm } = useContext(MediaQuery);
  const history = useHistory();
  const { onInsertUserActionLogOne } = useUserActionLog();

  return (
    <>
      <HomeComponentContainer
        padding={sm ? '100px 16px' : md ? '120px 36px' : '140px 0'}
      >
        <CustomizedTypography
          variant="h1"
          fontWeight="700"
          className={mainTitle}
          align="left"
          gutterBottoms={40}
        >
          자주 묻는 질문
        </CustomizedTypography>
        <Box className={container}>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                파트너와는 어떻게 연결되나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1" gutterBottoms={24}>
                  파트너와 연결되기 위해선 먼저 <b>&lt;견적 요청하기&gt;</b> 를
                  통해 견적을 작성해야 합니다. <br /> <b>&lt;견적 요청&gt;</b>{' '}
                  작성을 위해선 먼저 어떤 서비스(CNC, 금형사출 등)를 선택할지,
                  세부 가공방식은 무엇으로할 지 선택해야 하며 세부 가공방식은
                  파트너 추천받기를 선택해 상담 후 결정할 수 도 있습니다. 견적
                  요청 작성을 완료하셨다면, 고객님의 견적 요청에 관심을 가진
                  파트너가 먼저 채팅 메시지나 견적가를 보냅니다. 채팅방에서
                  메시지나 견적가를 확인하고 해당 파트너와 상담할 수 있습니다
                </CustomizedTypography>
                <CustomizedButton
                  size="large"
                  onClick={() => {
                    history.push('/request');
                  }}
                >
                  견적요청 작성하러 가기
                </CustomizedButton>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                도면이 없이도 제작이 가능한가요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1" gutterBottoms={24}>
                  2D, 3D 도면 데이터가 없는 경우 <b>&lt;디자인/설계&gt;</b>
                  서비스를 이용하면 도면 제작이 가능합니다. <br />{' '}
                  <b>&lt;견적 요청하기&gt;</b>에서 <b>&lt;디자인/설계&gt;</b>{' '}
                  서비스를 선택한 뒤 <b>&lt;제품디자인&gt;</b> 옵션을 선택하여
                  만들고자 하는 제작물의 이미지나 디자인 시안, 포트폴리오 등을
                  상세하게 올려주시면 견적을 산정하는데 도움이 됩니다. 기구설계
                  서비스에 대해 궁금하다면 아래 캐파 블로그를 통해 보다 자세한
                  내용을 확인해주세요.
                </CustomizedTypography>
                <CustomizedButton
                  size="large"
                  onClick={() =>
                    window.open(
                      'https://capa.ai/blog/posts/%EC%B9%B4%ED%8C%8Ccapa%EA%B0%80-%EC%A0%9C%ED%92%88-%EB%94%94%EC%9E%90%EC%9D%B8-%EC%84%9C%EB%B9%84%EC%8A%A4%EB%A5%BC-%EC%83%88%EB%A1%AD%EA%B2%8C-%EC%8B%9C%EC%9E%91%ED%95%A9%EB%8B%88%EB%8B%A4'
                    )
                  }
                >
                  디자인/설계 자세히보기
                </CustomizedButton>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                견적 요청 전에 대략적인 견적가를 알 수 없나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  견적가를 산정하기 위해서 이를 판단할 기본적인 자료가
                  필요합니다. <br /> 이에 캐파는 고객에게 도면을 비롯해 견적
                  산정에 필요한 필수 정보를 요청하고 있습니다. 다만, 캐파는
                  고객과 파트너를 직접 연결하는 서비스이기 때문에 캐파가 직접
                  견적을 산출하지는 않습니다. 견적가를 확인하고 싶다면 홈페이지
                  내에서 <b>&lt;견적 요청&gt;</b>을 신청해주실 것을 부탁
                  드립니다. 정확한 견적을 산정하기 위해선 도면이 반드시
                  필요합니다. 만약 도면이 없다면 <b>&lt;디자인/설계&gt;</b>{' '}
                  서비스의 <b>&lt;제품디자인&gt;</b> 옵션을 선택하여 도면을
                  제작하실 수 있습니다.
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                파트너와 분쟁 발생 시 어떻게 해야 하나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  캐파는 고객과 파트너가 '직접' 연결될 수 있도록 간 도와주는
                  매칭 서비스입니다.
                  <br /> 모든 소통은 고객과 파트너 간에 직접적으로 이뤄지고
                  캐파는 개입하지 않는 것이 원칙입니다. <br />
                  비록 캐파가 직접적으로 개입하여 문제를 해결할 수는 없으나,
                  문제 상황이 발생했다면 아래 이메일을 통해 접수해 주시기
                  바랍니다. <br />
                  <br />
                  Email : <a href="mailto:support@capa.ai">
                    support@capa.ai
                  </a>{' '}
                  <br /> 캐파 매니저가 파트너와 연락해 구체적인 상황을 확인하고
                  분쟁이 원만하게 해결될 수 있도록 도와드리겠습니다.
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                도면 보안에 대해서 궁금해요.
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  캐파에서 견적 요청을 위해 첨부한 도면은 캐파 파트너들에게만
                  공개됩니다. <br />
                  저희 캐파 서비스에 가입한 파트너는 보안을 위해 아래와 같은
                  약관 동의 절차를 거쳤습니다. <br /> <br />
                  제 19 조 (파트너 회원의 서비스 관련 의무) <br />
                  ⑥ 파트너 회원은 요청서의 내용과 도면 등 프로젝트 정보를
                  안전하게 관리하여야 하며, 고객의 동의 없이 제3에게 유출하거나
                  다른 목적으로 활용해서는 아니되며, 이를 위반하여 문제가 발생할
                  경우 고객의 피해를 보상해야 할 뿐 아니라 파트너 회원의 노력과
                  비용으로 회사를 면책시켜야 하며 서비스의 대외 이미지 실추
                  등으로 인하여 회사에 유무형적으로 손해가 발생할 경우 이를
                  배상할 책임이 있습니다. <br /> <br />
                  제 27 조 (비밀유지) <br />① 당사자는 서비스를 이용하는
                  과정에서 알게 된 상대방의 정보 또는 이용자의 정보를 제3자에게
                  누설, 공개하지 아니합니다. <br />
                  ② 본 조는 이용계약이 해지되거나 서비스 제공이 중단된 이후에도
                  유효합니다. <br /> <br />
                  <a href="https://capa.ai/terms/service">
                    [이용약관 바로가기]
                  </a>{' '}
                  <br /> <br />
                  또한 견적 요청 시 <b>'허용된 파트너만 다운로드 권한 가능'</b>
                  을 선택하면, 고객이 파트너에게만 도면을 다운로드할 수 있는
                  권한을 부여할 수 있습니다. 도면 다운로드를 제한할 경우 나머지
                  파트너들은 캐파 사이트 내 뷰어를 통해서만 도면을 확인할 수
                  있습니다. <br />
                  캐파는 도면 보안 기능을 강화하기 위해 현재{' '}
                  <b>
                    도면의 일부분을 가리거나 '블러' 처리할 수 있는 기능을 추가할
                    예정
                  </b>
                  입니다. <br />
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                캐파결제란?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  캐파결제는 온라인 제조 플랫폼 캐파(CAPA)에서 거래 시 직접
                  대금을 결제할 수 있는 서비스입니다. 혹시 모를 분쟁 상황에
                  대비하기 위해 고객이 제품 검수 후 구매를 확정한 뒤에
                  제조업체(파트너)측에 대금을 지급하는 ‘에스크로’ 결제 방식으로
                  이뤄집니다.
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                캐파결제는 어떻게 이용하나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  캐파결제는 다음과 같이 진행됩니다. <br />
                  1. 고객이 주문(발주)과 함께 계약대금을 결제하면, <br />
                  2. 캐파가 당분간 계제대금을 예치해둡니다. <br />
                  3. 주문을 받은 제조업체가 제품을 완성해 고객에게 배송하면,{' '}
                  <br />
                  4. 고객이 제품을 확인한 뒤 캐파에 ‘구매 확정’ 을 하고, <br />
                  5. 제조업체에 대금이 최종 지급됩니다.
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                캐파결제 수수료는 얼마나 내야 하나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant={'body1'} gutterBottoms={4}>
                  주문을 수주한 파트너(제조업체)가 부담하는 수수료는 결제망
                  이용료와 결제관리 수수료를 합산한 금액입니다.
                </CustomizedTypography>
                <CustomizedTypography
                  variant={'body2'}
                  fontWeight={'500'}
                  gutterBottoms={8}
                >
                  먼저, 결제망 이용료는 결제시스템을 제공하는 외부업체에
                  지불하는 비용입니다. 구체적인 비용은 결제 수단 별로 아래와
                  같습니다. (VAT 별도)
                </CustomizedTypography>
                <CustomizedTypography
                  variant={'caption'}
                  color={'textSecondary'}
                  gutterBottoms={6}
                >
                  결제망 이용료 (VAT 별도)
                </CustomizedTypography>
                <table className="tableContent">
                  <tbody>
                    <tr>
                      <th>신용/체크카드</th>
                      <td>3.3%</td>
                    </tr>
                    <tr>
                      <th>무통장입금</th>
                      <td>1,000 원</td>
                    </tr>
                  </tbody>
                </table>
                <CustomizedTypography
                  className="subTitle"
                  variant={'body2'}
                  gutterBottoms={8}
                >
                  2.결제 관리 수수료는 캐파에서 결제 시스템을 운영하는데 필요한
                  비용입니다.
                </CustomizedTypography>
                <CustomizedTypography
                  variant={'caption'}
                  color={'textSecondary'}
                  gutterBottoms={6}
                >
                  결제 관리 수수료 (VAT 별도)
                </CustomizedTypography>
                <table className="tableContent">
                  <tbody>
                    <tr>
                      <th>0원~500,000원</th>
                      <td>5%</td>
                    </tr>
                    <tr>
                      <th>500,001원~2,000,000원</th>
                      <td>3%</td>
                    </tr>
                    <tr>
                      <th>2,000,001원~5,000,000원</th>
                      <td>2%</td>
                    </tr>
                    <tr>
                      <th>5,000,001원~</th>
                      <td>1%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Landing_FAQ,
                  CapaActivityType.ButtonClick
                );
              }}
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="imgContainer">
                <img src={QUESTION_Q} alt="QUESTION_Q" />
              </div>
              <CustomizedTypography variant={sm ? 'body1' : 'h4'}>
                캐파결제 서비스 이용료가 있나요?
              </CustomizedTypography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="imgAnswer">
                <img src={ANSWER_A} alt="ANSWER_A" />
              </div>
              <div>
                <CustomizedTypography variant="body1">
                  캐파에서 제조 주문을 하는 고객은 무료로 캐파결제를 이용할 수
                  있습니다. 다만, 주문을 수주한 파트너(제조업체)는 결제망 이용
                  등에 대한 소정의 수수료를 부담합니다. 수수료는 거래 금액과
                  결제 방식에 따라 차등 부과됩니다.
                </CustomizedTypography>
              </div>
            </AccordionDetails>
          </Accordion>
        </Box>
      </HomeComponentContainer>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    width: '100%',
    minWidth: 343,
    maxWidth: 960,
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px'
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
}));

export default CapaQuestion;
